import './vendor';
// import Kladr from 'jquery.kladr';
import hideBlocks from './content/hide_blocks';
import megaMenu from './common/mega-menu';
import slider from './sliders/slider';
import searchAutocomplete from './common/search-autocomplete';
import searchAutocompleteMenu from './common/search-autocomplete-menu';
import searchGeo from './common/search-geo';
import sliderProducts from './sliders/catalog-products';
import {initProductGallery} from './sliders/product';
import photoSwipe from './vendor/init.PhotoSwipe';
// import jsShare from './vendor/js-share';
// import {initShow} from './product/tabs/show';
// import cackleLastReview from './product/cackle-last-review';
// import {initFilterControl, btnFilterControl} from './common/firlter/firlter-control';
// import productTab from './sliders/product-tab';
import feedSwipe from './sliders/feed_swiper';
// import {initSubscribe} from './common/subscribe';
// import {initInfra} from './sliders/infra';
// import {initTags} from './sliders/tags';
import {initProfessionalConsultancy} from './common/professional-consultancy';
import CallAdd from './cart/call-add';
import Form from './modal/form';
import FormContent from './modal/form-content';

// window.kladr = Kladr;

window.$(() => {
    $(document).foundation();
    hideBlocks();
    megaMenu();
    slider();
    searchAutocomplete();
    searchAutocompleteMenu();
    searchGeo();
    sliderProducts();
    initProductGallery();
    photoSwipe('.swipe-gallery');
    // // jsShare('.social_share');
    // initShow();
    // cackleLastReview();
    //
    // if ($(btnFilterControl).length) {
    //     initFilterControl();
    // }
    //
    // productTab();
    feedSwipe();
    // initSubscribe();
    // initInfra();
    // initTags();
    initProfessionalConsultancy();

    CallAdd.run();
    Form.run();
    FormContent.run();
});

// require('./vendor/ajaxupload');
